<div class="forgotpass_header">
   <!-- <span class="ftxt">Forgot Password</span>  -->
    <div class="icons_container" (click)="closepopUp()">
        <span class="ftxt" class="ftxt">Forgot Password</span>
        <span class="material-icons">
            clear
        </span>
    </div>
</div>
<div>
    <form [formGroup]="forgotpasswordForm">
        <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput placeholder="Enter  Email" formControlName="email">
        </mat-form-field>
        <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
            <mat-error *ngIf="f.email.errors.required">Email is required</mat-error>
        </div>
    </form>
    <button mat-flat-button color="primary" (click)="forgotpass()">
        Send Reset Password Link
    </button>
    <button mat-flat-button (click)="closepopUp()">
        cancel
    </button>
</div>


